import { BooleanInput } from '@angular/cdk/coercion';
import { SelectionModel } from '@angular/cdk/collections';
import { Directive, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableComponent } from '@app/modules/table/table.component';
import { FuiDestroyService } from '@services/destroy.service';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Директива для обработки выбора строки таблицы
 */
@Directive({
    selector: '[selectRow]',
    providers: [FuiDestroyService],
})
export class SelectRowDirective {
    readonly #table: TableComponent = inject(TableComponent);
    readonly #destroy$ = inject(FuiDestroyService);

    #isMultiple: boolean = false;

    #subscription: Subscription;

    @Input()
    set isMultiple(val: BooleanInput) {
        this.#isMultiple = val !== false && val !== null;
        const selectedVals = [];
        if (this.#isMultiple) {
            selectedVals.push(...this.#table.selection.selected);
        } else if (this.#table.selection.selected.length) {
            selectedVals.push(this.#table.selection.selected[0]);
        }
        this.#table.selection = new SelectionModel(this.#isMultiple, selectedVals);
        this.#subscription?.unsubscribe();
        this.#subscription = this.#table.selection.changed.pipe(takeUntil(this.#destroy$)).subscribe(() => {
            const newSelection = [];
            if (this.#isMultiple) {
                newSelection.push(...this.#table.selection.selected);
            } else if (this.#table.selection.selected.length) {
                newSelection.push(this.#table.selection.selected[0]);
            }
            this.selection.emit(newSelection);
        });
    }

    @Output() selection: EventEmitter<any> = new EventEmitter();
}
